import './App.css';
import { BrowserRouter , Routes , Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import AddBook from './components/AddBook';
import AboutUs from './components/AboutUs';
import Books from './components/Book/Books';
import BookDetail from './components/Book/BookDetail';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Header/>
      <Routes>
        <Route path='/' element={<Home/>} exact />
        <Route path='/add' element={<AddBook/>} exact/>
        <Route path='/books' element={<Books/>} />
        <Route path='/about' element={<AboutUs/>} exact/>
        <Route path='/books/:id' element={<BookDetail/>} exact />
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
